/**
 * Gemeinsame Helfer fuer die Zeitraum-Auswahl des Statistik-Dashboards.
 *
 * Die Validierung lebt bewusst NUR hier: DashboardPage (steuert das Laden)
 * und DateRangePicker (zeigt den Hinweis) haben die Regel frueher jeweils
 * eigenstaendig implementiert und koennten auseinanderlaufen.
 */

/**
 * Fruehestes waehlbares Datum der Zeitraum-Felder. Aeltere Werte sind
 * fachlich sinnlos (mvgen existiert erst danach) und wuerden nur
 * unnoetig grosse Zeitreihen erzeugen.
 */
export const MIN_SELECTABLE_DATE = '2000-01-01';

/** Zweistellige Formatierung (4 -> "04"). */
function pad2(value: number): string {
  return String(value).padStart(2, '0');
}

/**
 * Heutiges Datum als ISO-Datum (YYYY-MM-DD) in der lokalen Zeitzone.
 * Dient als Obergrenze der Datumsfelder: Zukunftsdaten liefern keine Daten.
 */
export function todayIsoDate(): string {
  const now = new Date();
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
}

/**
 * Prueft, ob ein gewaehlter Zeitraum ungueltig ist (Von liegt nach Bis).
 * Leere Werte bedeuten "Server-Default" und sind nie ungueltig.
 * Der ISO-Datumsstring ist lexikographisch sortierbar, daher genuegt
 * der String-Vergleich.
 */
export function isDateRangeInvalid(from: string, to: string): boolean {
  return from !== '' && to !== '' && from > to;
}
